// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  customerId: __t.string(),
  productId: __t.string(),
  priceId: __t.string(),
  status: __t.string(),
  quantity: __t.i32(),
  cancelAt: __t.option(__t.timestamp()),
  canceledAt: __t.option(__t.timestamp()),
  cancelAtPeriodEnd: __t.bool(),
  collectionMethod: __t.string(),
  lastEventAt: __t.timestamp(),
};
